var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2055_3676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.823 26.3926C7.16224 26.3711 1.50245 21.0494 1.47276 14.0489C1.44473 7.30067 7.01546 1.72498 13.7901 1.71344C20.5795 1.70189 26.1288 7.24954 26.142 14.0588C26.1535 20.8235 20.6059 26.3794 13.823 26.3926ZM15.3534 15.8629H15.3518C15.3518 15.1225 15.3518 14.3836 15.3518 13.6432C15.3518 13.602 15.3518 13.5607 15.3485 13.5195C15.3073 12.629 14.7944 11.8094 14.0127 11.6412C13.3827 11.5059 12.7115 11.5092 12.0618 11.5389C11.5967 11.5604 11.2702 12.0188 11.2521 12.4888C11.2356 12.9242 11.5011 13.3299 11.9463 13.4436C12.258 13.5228 12.5928 13.5245 12.9193 13.5393C13.17 13.5508 13.3003 13.6448 13.2986 13.9087C13.2953 15.3748 13.2953 16.8408 13.2986 18.3069C13.2986 18.5675 13.1848 18.6813 12.9259 18.678C12.667 18.6763 12.4031 18.6681 12.1475 18.7044C11.6281 18.7786 11.2718 19.1809 11.2488 19.674C11.2273 20.1539 11.5308 20.6388 12.0502 20.6569C13.5641 20.7113 15.083 20.7064 16.5985 20.6569C17.09 20.6404 17.3983 20.1655 17.395 19.707C17.3917 19.2453 17.0421 18.8115 16.5589 18.7192C16.3066 18.6714 16.0411 18.6681 15.7822 18.678C15.4639 18.6895 15.3402 18.5642 15.3468 18.2442C15.36 17.4494 15.3518 16.6545 15.3518 15.8596L15.3534 15.8629ZM14.0935 6.86365C13.236 6.8554 12.5466 7.52495 12.5334 8.3759C12.5202 9.22025 13.2129 9.92772 14.0539 9.93267C14.8785 9.93761 15.5827 9.25323 15.5942 8.43526C15.6074 7.57277 14.9362 6.87189 14.0935 6.86365Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2055_3676",
    x: 1.47266,
    y: 1.71342,
    width: 24.6694,
    height: 25.6791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2055_3676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2055_3676",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.534d5406782d22a58d054c50a433f9e5.svg";
export { ForwardRef as ReactComponent };